/**
 * @author xiaohuangmaoth
 * @description 培训路径信息
 * @Date 2021/3/31
 */
import React from "react";
import PropTypes from "prop-types";
import { component_tool } from "@/tool";
import { AudienceGroupItem } from '@/components';
import "./trainPathInfo.less";

const { WizComponent, WizCard } = component_tool;
export default class TrainPathInfo extends WizComponent {

  render() {
    const { name, fileUri, state, requiredTargetScope, electiveTargetScope, briefIntroduction } = this.props;
    const stateMap = ['草稿', '已发布', '已关闭', '建设中']
    return (
      <WizCard title={"培训路径信息"}>
        <div className="trainPath-info-wrp">
          <div className="trainPath-info-head">
            <img src={fileUri} />
            <span className="trainPath-info-status">
              {/* { !state || state === 1
                ? "草稿"
                : state === 2
                ? "已发布"
                : "已关闭"} */}
                {stateMap[state - 1]}
            </span>
          </div>
          <div className="trainPath-info-body">
            <div className="trainPath-descriptions-wrp">
              <div className="trainPath-descriptions-title">{name}</div>
              <div className="trainPath-descriptions-item">
                <span className="item-label">必修范围: </span>
                <span className="item-value">
                  <AudienceGroupItem {...requiredTargetScope} isModal />
                </span>
              </div>
              <div className="trainPath-descriptions-item">
                <span className="item-label">选修范围: </span>
                <span className="item-value">
                  <AudienceGroupItem {...electiveTargetScope} isModal />
                </span>
              </div>
              <div className="trainPath-descriptions-item">
                <span className="item-label">介绍: </span>
                <span className="item-value">{briefIntroduction}</span>
              </div>
            </div>
          </div>
        </div>
      </WizCard>
    );
  }
}

TrainPathInfo.defaultProps = {
  data: {},
};

TrainPathInfo.propTypes = {
  data: PropTypes.object,
};
